/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ service: NonNullable<unknown>, city: NonNullable<unknown> }} Directory_Meta_DescriptionInputs */

const en_directory_meta_description = /** @type {(inputs: Directory_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.service}, ${i?.city}: compare specialists, prices and open times, and book online.`)
};

const pl_directory_meta_description = /** @type {(inputs: Directory_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.service}, ${i?.city}: porównaj specjalistów, ceny i wolne terminy, umów się online.`)
};

/**
* | output |
* | --- |
* | "{service}, {city}: compare specialists, prices and open times, and book online." |
*
* @param {Directory_Meta_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const directory_meta_description = /** @type {((inputs: Directory_Meta_DescriptionInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Meta_DescriptionInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_directory_meta_description(inputs)
	return en_directory_meta_description(inputs)
});